import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import { guid } from '@/mixins/guid';
import EditGroup from './edit-group';
import newGroup from './new-group';

export default Vue.component('type-groups', {
  template: require('./template.html'),
  name: 'type-groups',
  mixins: [dynamicSetup, guid],
  components: {
    EditGroup,
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    groups() {
      const fullList = this.allGroups;
      const sortOn = 'created';
      return _.chain(fullList)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.col, (c) => {
                  e.push(row[c]);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line

          return (a === b ? 0 : a < b ? -1 : 1) * -1; // eslint-disable-line
        })
        .value();
    },
    typeData() {
      return this.currentSite.dynamic[this.activeSiteType];
    },
  },
  data() {
    return {
      filterKey: '',
      col: ['alias'],
      paginate: ['groups'],
      group: '',
      groupError: false,
      activeGroup: null,
      paginateLimit: 8,
    };
  },
  props: [
    'item-modal',
    'content',
    'active-item',
    'item-list',
    'all-groups',
    'dynamic-data',
    'all-categories',
  ],
  watch: {
    content(content) {
      if (content !== 'groups') {
        this.activeGroup = null;
      }
    },
  },
  methods: {
    async addGroup() {
      this.groupError = false;
      if (this.group.trim() === '') {
        return;
      }
      if (_.find(this.allGroups, g => g.name === this.group)) {
        this.groupError = 'A group with that name already exists.';
        return;
      }
      this.$emit('set-loading', true);
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Group Successfully Added!',
      };
      try {
        if (this.noDynamicData(this.activeSiteType)) {
          this.dynamicSetup(this.activeSiteType);
        }

        if (!this.typeData.groups) {
          this.$store.dispatch('setDropletVal', {
            drp: this.typeData,
            key: 'groups',
            val: [],
          });
        }

        this.$store.dispatch('pushDropletVal', {
          array: this.typeData.groups,
          val: newGroup({
            name: this.group,
            alias: this.group,
          }),
        });

        this.group = '';

        await this._SEND([{
          name: 'updateSiteAttr',
          payload: {
            siteId: this.currentSite._id,
            attr: 'dynamic',
            value: this.currentSite.dynamic,
          },
        }]);

        this.$log.debug('successfully added new group');
      } catch (e) {
        this.$log.error('error: ', e);
        notif.type = 'error';
        notif.message = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'addGroup',
        });
      } finally {
        this.$emit('set-loading', false);
        this.$store.dispatch('addNotification', notif);
      }
    },
    highlight(ctx, query) {
      return ctx.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/groups/index.js